import { render, staticRenderFns } from "./HotelData.vue?vue&type=template&id=7b6f0f5f&scoped=true&"
import script from "./HotelData.vue?vue&type=script&lang=js&"
export * from "./HotelData.vue?vue&type=script&lang=js&"
import style0 from "./HotelData.vue?vue&type=style&index=0&id=7b6f0f5f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6f0f5f",
  null
  
)

export default component.exports